<template>
    <div class="modal fade" :id="'updateParticipantsModal' + _uid" role="dialog" aria-labelledby="updateParticipantsModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateParticipantsModalLabel">{{ model.modalTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <participants-edit-card v-model="model"
                                            @save="onSave"
                                            @cancel="onCancel"
                    ></participants-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ParticipantsUpdateModel } from '../../models/models';
    import ParticipantsEditCard from './ParticipantsEditCard';

    export default {
        components: {
            ParticipantsEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                model: new ParticipantsUpdateModel(),
            };
        },
        methods: {
            onClose(e, fromBtn) {
                if ((e && e.target.id === `updateParticipantsModal${this._uid}`) || fromBtn === true) {
                    this.$emit('onClose', { ...this.model });
                    this.model = new ParticipantsUpdateModel();
                } else {
                    $(this.$el).focus();
                }
            },
            hide(e) {
                $('#updateParticipantsModal' + this._uid).modal('hide');
            },
            onSave(model) {
                this.$emit('onSave', model);
                this.onClose(null, true);
            },
            onCancel() {
                this.onClose(null, true);
            }
        },
        mounted() {
            // add modal close listener
            $('#updateParticipantsModal' + this._uid).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $('#updateParticipantsModal' + this._uid).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new ParticipantsUpdateModel(this.value);

                    $('#updateParticipantsModal' + this._uid).modal('show');
                } else {
                    $('#updateParticipantsModal' + this._uid).modal('hide');
                }
            }
        }
    };
</script>
